import React from "react"

import Toggle from "./../general/Toggle"
import Thumbnail from "./../detail/GameInfo/Thumbnail"

import { Link } from "react-router-dom"

class GameTitle extends React.Component{
    static parseISOString = (ISOString) =>{
        let date = new Date(ISOString)
        let year = date.getFullYear()
        let month = date.getMonth()+1
        let dt = date.getDate()
        let hour = date.getHours()
        let min = date.getMinutes()
    
        dt = dt >= 10? dt : `0${dt}`;
        month = month >= 10 ? month : `0${month}`;
        hour = hour >= 10 ? hour : `0${hour}`
        min = min >= 10 ? min : `0${min}`
        return `${year}-${month}-${dt} ${hour}:${min}`
    }
    togglePrivate = (state) =>{
        fetch(`/api/data/project/${this.props.id}/set_private`,{
            method: "post",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                value: state,
            })
        })
        .then(res => res.json())
        .then(data => console.log(data))
    }
    render(){
        const { id, imgUrl, gameName, createdAt, updatedAt, isPrivate } = this.props
        return(
            <div className="basicInfo">
                <Thumbnail gameName={gameName} imgUrl={imgUrl} />
                <div className="gameTitle">
                    <div className="wrapper">
                        <Link to={{
                                    pathname: "/arcade/game/" + id
                                }}>
                            <h1 className="gameName">{gameName}</h1>
                        </Link>
                        <div className="meta">
                            <div className="col">
                                <div className="date">
                                    Created at: {GameTitle.parseISOString(createdAt)}
                                </div>
                                <div className="date">
                                    Last updated at: {GameTitle.parseISOString(updatedAt)}
                                </div>
                            </div>
                        </div>
                        <Toggle toggleName="Private:" checked={isPrivate}
                            toggleMessage={["Private projects are only visible to yourself and invited testers;",
                            "\n", "non-private projects are visible to community users."]}
                            onToggle={this.togglePrivate}/>
                        </div>
                </div>
            </div>
        )
    }
}

export default GameTitle